import axios from "axios";
import Config, { GetEnv } from "../utils/config";
import Const from "../utils/const";
import Auth from "../utils/auth";
import { getSmsType } from "../page/localStorage";

/**
 * params:{
 *      url     : '/user',
 *      method  : 'get',
 *      baseURL : 'https://some-domain.com/api/',
 *      params  : {
 *          ID: 12345
 *      },
 *      data    : {
 *          firstName: 'Fred'
 *      },
 *      headers: {'X-Requested-With': 'XMLHttpRequest'}
 * }
 */

// Ops 转发的Backend，ops本身不需要Backend
export const OpsBackend = {
  // 运营平台相关服务
  UsmsBackend: 'Usms',
  OrderBackend: 'Order',

  // uspeedo内部服务
  AccountBackend: 'USAccount',
  BillBackend: 'USBill',
  TicketBackend: 'USTicket',

  // 老的中台服务
  UaclBackend: 'Uacl',
}

export default function Req(params) {
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: "",
      timeout: 30000,
      method: "get"
    });

    instance.interceptors.request.use(
      config => {
        config.headers["service-ticket"] = Auth.getLocalAuthInfo() || "";
        config.headers["x-forwarded-user"] = Auth.getLocalAuthName() || '';
        config.headers["remote_user"] = Auth.getLocalAuthName() || '';
        // HACK:  for development.
        if (GetEnv() === Const.ENV_DEV) {
          if (!config.params) {
            config.params = {};
          }
          if (!config.headers) {
            config.headers = {};
          }
          config.headers["x-forwarded-user"] = Auth.getLocalAuthName() || "yonge.li";
          config.headers["remote_user"] = Auth.getLocalAuthName() || "yonge.li";
        }
        return config;
      },
      error => {
        error.msg = error.props || Const.PARAMS_ERROR;
        return Promise.reject(error);
      }
    );

    instance.interceptors.response.use(
      res => {
        return res;
      },
      error => {
        error.msg = error.props || Const.HTTPRES_ERROR;
        return Promise.reject(error);
      }
    );

    instance(params)
      .then(res => {
        if (res.data.RetCode && res.data.RetCode === Const.API_NOT_LOGIN_CODE) {
          Auth.clearLocalAuthInfo();
          window.location.reload();
        } else if (res.data.RetCode && res.data.RetCode === Const.NO_PERMISSION_CODE) {
          resolve(res.data);
        } else if (res.data.RetCode && res.data.RetCode === Const.UX_RET_CODE) {
          resolve(res.data);
        } else if (res.data.RetCode && res.data.RetCode !== Const.API_SUCCESS_CODE) {
          // resolve(res.data);
          throw new Error(res.data.Message);
        }
        resolve(res.data);
        return false;
      })
      .catch(error => {
        error.msg = error.props || Const.PARAMS_ERROR;
        reject(error);
      });
  });
}

function ApiFetch(action, params, getResult, adminAction) {
  return Req({
    method: "post",
    baseURL: "",
    url: Config.OpsAPI[GetEnv()],
    timeout: 60000,
    data: {
      Action: action,
      AdminAction: adminAction,
      SMSCategory: getSmsType() || "Text",
      ...params
    },
    headers: { remote_user: Auth.getLocalAuthName() }
  }).then(res => {
    return getResult ? getResult(res) : res;
  });
}

export const GetCompanyInfo = params => ApiFetch("GetCompanyInfo", {...params, Backend: OpsBackend.AccountBackend}, res => res);
export const GetAccountInfo = params =>
  ApiFetch("GetAccountInfo", {...params, Backend: OpsBackend.AccountBackend}, res => res);
export const DescribeCustomer = params => ApiFetch("DescribeCustomer", params, res => (res && res.Data) || []);

